import { useNuxtApp } from "#app";
import { BaseService } from "../base/base.service";
import { ModelGETUserDetail, ModelUserAuth, type IModelLoginRequest } from "./dto/jwt.dto";
import { JWTRepository } from "./jwt.repository";


export class JWTService extends BaseService {
  private jwtRepository = new JWTRepository(this.api, this.configService);

  async login(params: IModelLoginRequest): Promise<ModelUserAuth | undefined> {
    const { $functions } = useNuxtApp()
    let dataResult;
    try {
      const res = await this.jwtRepository.login(params);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = new ModelUserAuth(resData.data)
        console.log('login', resData.data, dataResult)
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message,
        isError: true
      });
      console.log(err, JWTService.name);
    }
    return dataResult;
  }

  async getUserDetail(id: string | number): Promise<ModelGETUserDetail> {
    const { $functions } = useNuxtApp();
    let dataResult = new ModelGETUserDetail();
    try {
      const res = await this.jwtRepository.getUserDetail(id);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = new ModelGETUserDetail(resData.data);
        console.log('getUserDetail', resData.data, dataResult);
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message
      });
      console.log(err, JWTService.name);
    }

    return dataResult;
  }

  async logout(): Promise<boolean> {
    const { $functions } = useNuxtApp();
    let isSuccess = false;
    try {
      const res = await this.jwtRepository.logout();
      const resData = res.data.value;
        isSuccess = true;
        console.log('logout', resData);
    } catch (err: any) {
      // Ignore error and continue with logout process
      console.log('Logout error (ignored):', err, JWTService.name);
      isSuccess = true;
    }
    return isSuccess;
  }

}
